// extracted by mini-css-extract-plugin
export default {"wrapper":"TimerBlock_wrapper__WqyT8"};